import type { FileId, UserDomainQueryModel } from '@mntn-dev/domain-types'
import { type Person, toPerson } from '@mntn-dev/ui-components'

export type GetAvatarUrl = (fileId: FileId | undefined) => string | undefined

export const userDomainQueryModelToPerson = (
  model: UserDomainQueryModel | null,
  getAvatarUrl: GetAvatarUrl
): Person => {
  return toPerson({
    firstName: model?.firstName || '-',
    lastName: model?.lastName || '-',
    avatarFileId: model?.avatarFileId,
    avatarUrl: getAvatarUrl(model?.avatarFileId),
  })
}
